import $ from 'jquery';
(function(){
    'use strict';

    // Global variables
    var squiz = {
        'fn': {},
        'vars': {}
    };

    /**
     * Toggle the mobile menu elements on and off.
     * e.g. site search and main menu
     *
     * @param {String} buttonClass The unique Class name of the toggle button
     * @param {String} targetClass The unique Class name of the content to toggle
     *
     * @returns void
     */
    squiz.fn.mobileMenuToggle = (buttonClass, targetClass) => {
        const togglebutton = document.getElementsByClassName(buttonClass)[0];
        const searchContainer = document.getElementsByClassName(targetClass)[0];

        if (togglebutton && searchContainer) {
          togglebutton.addEventListener('click', event => {
              event.preventDefault();
              togglebutton.classList.toggle('is-active');
              searchContainer.classList.toggle('is-visible');
          });
        }

    };

    /**
     * Hijack the form submission action so that we can perform additional validation, use AJAX to submit the form and display the response
     *
     * @param {Object} handlerOptions. See link below.
     * {HTML Element} formElement The form to attach the submission handlers to. Required.
     * {String} loadingMessageMarkup Markup to insert into the loading indicator. Optional.
     * {Boolean} onLoadCallback This will be called upon completion of the request (success or fail). It will receive the request XHR event and the form's handler options. Optional.
     * {Boolean} scrollOnLoad Whether or not to scroll to the top of the page after the form submission (this is useful for long forms). Default = true. Optional.
     * {Function} validationFunction This will be called before the form is submitted. It will receive the form element and should return a Boolean. Optional.
     * {Function} validationFunctionAsync As above, but this is asynchronous and must return a Promise. A resolved Promise will mean validation passed, a rejected Promise will halt the form submission. Optional.
     *
     * @returns void
     *
     * @source https://app.marketplace.squiz.net/internal/matrix-ajax-forms
     */
    squiz.fn.initFormSubmissionHandler = (handlerOptions) => {

        const formOptions = {
            "formElement": null,
            "loadingMessageMarkup": '<p class="loading-message"><em>Loading form...</em></p>',
            "onLoadCallback": {},
            "scrollOnLoad": false,
            "validationFunction": function(){return true;},
            "validationFunctionAsync": null
        };
        let queryString = [];
        let parameterId = '';
        let submitButtons = {};

        // Update the default form options
        for (let prop in handlerOptions) {
            formOptions[prop] = handlerOptions[prop];
        }

        // Check that at least a form has been provided
        if (formOptions.formElement === null || formOptions.formElement === undefined) {
            console.log('Error: Unable to initialise initFormSubmissionHandler(). No form provided.', formOptions);
            return;
        }

        // Insert the loading animation/message into the page
        formOptions.formElement.insertAdjacentHTML('beforeend', creatingLoadingMarkup(formOptions.loadingMessageMarkup));

        // Add a listener to each of the form's submit buttons so that we can track which button is submitting the form
        submitButtons = formOptions.formElement.querySelectorAll('[type=submit]');

        for (var i = 0, j = submitButtons.length; i < j; ++i) {
            submitButtons[i].addEventListener('click', function(evt){
                hijackFormSubmission(evt, formOptions);
            });
        }

        // Check if the user is continuing a saved submission
        queryString = window.location.href.split('?');
        parameterId = '';

        // Check if: there are query parameters
        if (queryString[1]) {
            // Extract the FORM ID from the query string
            parameterId = queryString[1].match(/SQ_FORM_(.*?)(?=_SUBMISSION)/);

            // Check if: The parameters are for continuing a submission. The ID in the parameters matches the current form
            if (queryString[1].indexOf('_SUBMISSION') !== -1 && formOptions.formElement.getAttribute("id").indexOf(parameterId[1]) !== -1) {

                // The user is continuing a form submission
                // Remove the query from the URL to prevent an infinite loop once we load the saved form progress
                window.history.replaceState({}, document.title, location.protocol + "//" + location.host + location.pathname);

                // Make a GET request to retrieve the form submission
                continueFormSubmission(formOptions, queryString[1] + '&SQ_ASSET_CONTENTS_RAW');
            }
        }

        /**
         * Respond to attempts to submit the form
         *
         * @param {MouseEvent} evt The event that triggered the submission
         * @param {Object} handlerOptions The handler options for the form (as set in initFormSubmissionHandler())
         *
         * @returns void
         */
        function hijackFormSubmission(evt, handlerOptions) {
            let form = handlerOptions.formElement; // Capture the current form element
            let formSubmitter = evt.currentTarget;

            evt.preventDefault();

            // Show the loading message
            form.getElementsByClassName('js-loading-message')[0].classList.add('is-active');

            // Check if the form passes validation (and/or other pre-submit actions)
            if (isFunction(handlerOptions.validationFunction) && !handlerOptions.validationFunction(form)) {
                // Hide the loading message
                form.getElementsByClassName('js-loading-message')[0].classList.remove('is-active');
                return;
            }

            // Check if the form requires asynchronous validation
            if (handlerOptions.validationFunctionAsync) {
                // Call the additional validation method
                handlerOptions.validationFunctionAsync(form)
                    .then( (success) => {
                        if (success) {
                            // Form validation passed
                            submitFormViaAjax(formSubmitter, handlerOptions);
                        }
                    })
                    .catch( (success) => {
                        if (!success) {
                            // Form validation failed
                            // Hide the loading message
                            form.getElementsByClassName('js-loading-message')[0].classList.remove('is-active');
                        }
                    });
            } else {
                // Default behaviour for when no extra validation has been configured
                submitFormViaAjax(formSubmitter, handlerOptions);
            }
        }

        /**
         * Capture all of the form elements and POST the form using XHR
         *
         * @param {MouseEvent} eventTarget The event that triggered the submission
         * @param {Object} handlerOptions The handler options for the form (as set in initFormSubmissionHandler())
         *
         * @returns void
         */
        function submitFormViaAjax(eventTarget, handlerOptions) {
            const XHR = new XMLHttpRequest();
            let form = handlerOptions.formElement; // Capture all the form data
            let formData = new FormData(form); // Convert the form fields into FormData
            let formField = {};
            let submitBtn = {};
            let formSubmitter = eventTarget;

            // Perform some additional operations on the form data
            for (let i = 0, j = form.elements.length; i < j; ++i) {

                formField = form.elements[i];

                if (formField.name === '' || formField.disabled) {
                    // Skip the undefined and disabled elements
                    continue;
                }

                // Matrix requires the submit button to be part of the submission data
                // Find the submit button in the form inputs
                // Match the submit buttons found in the form to the button that initiated the form submission
                if (formField.type === 'submit') {

                    // Check if the user is submitting the form or saving form
                    if (formSubmitter.getAttribute("name").indexOf('_save') !== -1 && formField.getAttribute("name").indexOf('_save') !== -1) {
                        // Capture the save button element
                        submitBtn = formField;
                        break;
                    }

                    if (formSubmitter.getAttribute("name").indexOf('_previous_page') !== -1 && formField.getAttribute("name").indexOf('_previous_page') !== -1) {
                        // Capture the previous button element
                        submitBtn = formField;
                        break;
                    }

                    if (formSubmitter.getAttribute("name").indexOf('_submit') !== -1 && formField.getAttribute("name").indexOf('_submit') !== -1) {
                        // Capture the submit button element (standard form submit)
                        submitBtn = formField;
                        break;
                    }

                    if (formSubmitter.getAttribute("name").indexOf('_public_auth') !== -1 && formField.getAttribute("name").indexOf('_public_auth') !== -1) {
                        // Capture the submit button element (for the continue submission password form)
                        submitBtn = formField;
                        break;
                    }
                }
            }

            // Disable the submit button
            submitBtn.setAttribute("disabled", "");

            // Append the submit button to the form data
            formData.append(submitBtn.name, submitBtn.value);

            // Respond to requests to POST the form
            XHR.addEventListener('load', function(evt) {
                onFormRequestSuccess(evt, handlerOptions);
            });

            // Respond to request errors
            XHR.addEventListener('error', function(evt) {
                onFormRequestError(evt, handlerOptions, submitBtn);
            });

            // Callback function
            if (isFunction(handlerOptions.onLoadCallback)) {

                XHR.addEventListener('loadend', function(evt) {
                    handlerOptions.onLoadCallback(evt, handlerOptions);
                });
            }

            // Set up our request
            XHR.open("POST", generatePostURL(form.getAttribute('action')));

            // Make the request
            XHR.send(formData);
        }

        /**
         * Respond to the form submission LOAD event
         *
         * @param {ProgressEvent} evt The event as part of the XHR request
         * @param {Object} handlerOptions The handler options for the form (as set in initFormSubmissionHandler())
         *
         * @returns void
         */
        function onFormRequestSuccess(evt, handlerOptions) {
            const responseElementId = uuidv4();
            const replacePreviousResponse = handlerOptions.formElement.parentNode.classList.contains('js-ajax-form-response-wrapper');
            let responseElement = document.createElement('div');
            let responseElementWrapper = document.createElement('div');
            let responseElementScripts = null;

            // Set the ID on our wrapper so we can target it later (there may be multiple AJAX forms on one page)
            responseElementWrapper.setAttribute('id', responseElementId);

            // Set a hook Class on our wrapper so we can identify it later
            responseElementWrapper.setAttribute('class', 'js-ajax-form-response-wrapper');

            // Set the response in our new <div>
            responseElementWrapper.innerHTML = evt.currentTarget.response;

            // Check if there are any scripts that will need to be executed
            responseElementScripts = responseElementWrapper.getElementsByTagName('script');

            // Set our new <div> in the container so that we can keep our wrapper markup when inserting it into the DOM
            responseElement.appendChild(responseElementWrapper);

            // Insert the wrapper and response into the page
            if (replacePreviousResponse) {
                // There has already been a response, so insert the new response before that wrapper
                handlerOptions.formElement.parentNode.insertAdjacentHTML('beforebegin', responseElement.innerHTML);
            } else {
                // Insert the response before the original form
                handlerOptions.formElement.insertAdjacentHTML('beforebegin', responseElement.innerHTML);
            }

            // Check if the response contains another form (as a direct child)
            // E.g. for multi-page forms or when server-side validation has failed
            for (var i = 0, j = responseElementWrapper.childNodes.length; i < j; ++i) {
                if (responseElementWrapper.childNodes[i].nodeName.toLowerCase() === 'form') {

                    // Intialise the new form using the previous configuration options
                    const formOptions = {};

                    // Copy the previous form handler options
                    for (let prop in handlerOptions) {
                        formOptions[prop] = handlerOptions[prop];
                    }

                    // Set the new form as the target form
                    formOptions.formElement = document.getElementById(responseElementId).childNodes[i];

                    squiz.fn.initFormSubmissionHandler(formOptions);
                    break;
                }
            }

            // Remove the current form
            if (replacePreviousResponse) {
                // There has already been a response, so remove that wrapper
                handlerOptions.formElement.parentNode.parentNode.removeChild(handlerOptions.formElement.parentNode);
            } else {
                // Delete the original form (which won't have our wrapper)
                handlerOptions.formElement.parentNode.removeChild(handlerOptions.formElement);
            }

            // Run any scripts that are included with the response
            if (responseElementScripts.length > 0) {
                for (var n = 0, b = responseElementScripts.length; n < b; ++n) {
                    if (responseElementScripts[n].getAttribute('src') !== null) {
                        // The JavaScript is loaded into the page from another source

                        // Create a new <script> node
                        let newScript = document.createElement('script');

                        // Set the script source to match the original
                        newScript.setAttribute('src', responseElementScripts[n].getAttribute('src'));

                        // Traverse the DOM to get the original script node
                        let originalScript = document.getElementById(responseElementId).getElementsByTagName('script')[n];

                        // Insert our new script directly before the original
                        originalScript.parentNode.insertBefore(newScript, originalScript);
                    } else {
                        // The JavaScript is inline, so try to run it directly
                        try {
                            eval(responseElementScripts[n].innerHTML);
                        } catch (error) {
                            console.error('Error parsing form inline JavaScript. Error: ', error);
                        }
                    }
                }
            }

            // Scroll to the top of the page (if enabled)
            // This works well in Firefox and Chrome.
            // For Safari, Edge and IE11, it just snaps to the top of the page.
            if (handlerOptions.scrollOnLoad) {
                window.scrollTo({
                  top: 0,
                  left: 0,
                  behavior: 'smooth'
                });
            }
        }

        /**
         * Respond to the form submission ERROR event
         *
         * @param {ProgressEvent} evt The event as part of the XHR request
         * @param {Object} handlerOptions The handler options for the form (as set in initFormSubmissionHandler())
         * @param {HTMLElement} submitButton The button that initiated the form submission. Optional.
         *
         * @returns void
         */
        function onFormRequestError(evt, handlerOptions, submitButton) {
            console.log('Oops! Something went wrong.', evt);

            // Re-enable the submit button
            if (submitButton) {
                submitButton.removeAttribute("disabled");
            }

            // Hide the loading message
            handlerOptions.formElement.getElementsByClassName('js-loading-message')[0].classList.remove('is-active');
        }

        /**
         * Continue a previously saved form submission
         * Retrieve the resume form contents from Matrix
         *
         * @param {Object} handlerOptions The handler options for the form (as set in initFormSubmissionHandler())
         * @param {String} queryString The query string to use to continue the form submission. e.g. SQ_FORM_12345_SUBMISSION=123&SQ_FORM_12345_PAGE=1&SQ_FORM_12345_ACCESSID=123cd321cd347
         *
         * @returns void
         */
        function continueFormSubmission(handlerOptions, queryString) {
            const XHR = new XMLHttpRequest();

            // Show the loading message
            handlerOptions.formElement.getElementsByClassName('js-loading-message')[0].classList.add('is-active');

            // Respond to requests to GET the form
            XHR.addEventListener('load', function(evt) {
                onFormRequestSuccess(evt, handlerOptions);
            });

            // Respond to request errors
            XHR.addEventListener('error', function(evt) {
                onFormRequestError(evt, handlerOptions);
            });

            // Callback function
            if (Object.keys(handlerOptions.onLoadCallback).length !== 0 && isFunction(handlerOptions.onLoadCallback)) {

                XHR.addEventListener('loadend', function(evt) {
                    handlerOptions.onLoadCallback(evt, handlerOptions);
                });
            }

            // Set up our request
            XHR.open("GET", handlerOptions.formElement.getAttribute('action') + '?' + queryString);

            // Make the request
            XHR.send();
        }

        /**
         * Add the Matrix URL suffix to the URL that will remove all Designs and Paint Layouts
         *
         * @param {String} formAction The form request action (action attribute)
         *
         * @returns Form URL as a String
         */
        function generatePostURL(formAction) {
            const urlSuffix = 'SQ_ASSET_CONTENTS_RAW';

            // Check if there are already query parameters
            if (formAction.indexOf('?') !== -1) {
                return formAction + '&' + urlSuffix;
            } else {
                return formAction + '?' + urlSuffix;
            }
        }

        /**
         * Create a new loading message
         *
         * @returns HTML as a String
         */
        function creatingLoadingMarkup(loadingMessage) {
            return '<div class="js-loading-message loading-container"><div class="sk-chase"><div class="sk-chase-dot"></div><div class="sk-chase-dot"></div><div class="sk-chase-dot"></div><div class="sk-chase-dot"></div><div class="sk-chase-dot"></div><div class="sk-chase-dot"></div></div>' + loadingMessage + '</div>';
        }

        /**
         * Check if an Object is a function
         *
         * @param {Object} functionToCheck The Object to check
         *
         * @returns Boolean
         */
        function isFunction(functionToCheck) {
            return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
        }

        /**
         * Generate a (mostly) unique ID in an RFC4122 version 4 compliant format
         *
         * @returns String
         *
         * @source https://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid
         */
        function uuidv4() {
          return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, function(c) {
            return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
          });
        }
    };

    /**
     * Location lookup service
     *
     * Note: The configuration information is partially provided by the CMS and therefore will need to be printed into the page content.
     *
     * @usage
     * Configuration with examples:
     *
      const locationLookupConfiguration = {
        "geolocationButtonClass": "js-geolocation-lookup",
        "locationInputFieldClass": "js-location-lookup-input",
        "clearInputButtonClass": "js-outage-checker-clear-button",
        "locationSuggestionsListClass": "js-location-lookup-suggestions",
        "alertMessagePopupClass": "js-location-lookup-popup",
        "alertMessageContainerClass": "js-location-lookup-message",
        "alertMessageCloseButtonClass": "js-location-lookup-popup-close",
        "franchisePostcodes": ["2114","2115","2116","2117","2118"],
        "googlePlacesApiEndpoint": "https://www.endeavourenergy.com.au/designs/connectors/google/google-places-api",
        "googlePlaceDetailsApiEndpoint": "https://www.endeavourenergy.com.au/designs/connectors/google/google-place-details-api",
        "googleGeocodingApiEndpoint": "https://www.endeavourenergy.com.au/designs/connectors/google/google-geocoding-api"
      };
      squiz.fn.initLocationLookup(locationLookupConfiguration);
     *
     */
    squiz.fn.initLocationLookup = (configuration) => {
      // Check if the browser geolocation API is available for determining the user's location
      const geoLocationAvailable = ("geolocation" in navigator) ? true : false;

      // We use this to make our asynchronous requests for data
      let xhrDataRequest = new XMLHttpRequest();

      // Capture the DOM elements and add the listeners for the outage checker component
      let geoLookupButton = document.getElementsByClassName(configuration.geolocationButtonClass);
      let locationInputField = document.getElementsByClassName(configuration.locationInputFieldClass);
      let clearInputButton = document.getElementsByClassName(configuration.clearInputButtonClass);
      let locationSuggestionsDropdown = document.getElementsByClassName(configuration.locationSuggestionsListClass);
      let alertMessagePopup = document.getElementsByClassName(configuration.alertMessagePopupClass);
      let alertMessage = document.getElementsByClassName(configuration.alertMessageContainerClass);
      let alertMessagePopupCloseButton = document.getElementsByClassName(configuration.alertMessageCloseButtonClass);

      if (geoLookupButton.length !== 0) {
        geoLookupButton = geoLookupButton[0];
        geoLookupButton.addEventListener('click', onGeoLocateClick);

        if (!geoLocationAvailable) {
          // Disable the "Use my location" button
          geoLookupButton.setAttribute("disabled", "disabled");
        }
      }

      if (locationInputField.length !== 0) {
        locationInputField = locationInputField[0];
        locationInputField.addEventListener('input', onLocationInputChange);
      }

      if (clearInputButton.length !== 0) {
        clearInputButton = clearInputButton[0];
        clearInputButton.addEventListener('click', onClearInputClick);
      }

      if (locationSuggestionsDropdown.length !== 0) {
        locationSuggestionsDropdown = locationSuggestionsDropdown[0];
      }

      if (alertMessage.length !== 0) {
        alertMessage = alertMessage[0];
      }

      if (alertMessagePopup.length !== 0) {
        alertMessagePopup = alertMessagePopup[0];
      }

      if (alertMessagePopupCloseButton.length !== 0) {
        alertMessagePopupCloseButton = alertMessagePopupCloseButton[0];
        alertMessagePopupCloseButton.addEventListener('click', onAlertCloseClick);
      }

      /**
       * Respond to input on the location field
       *
       * @param {Change Event} evt Input Event that triggered the change
       */
      function onLocationInputChange(evt) {
        const { value } = evt.target;

        // Clear any user location that has been captured already
        setLocation({
          "suburb": "",
          "postcode": "",
          "latitude": "",
          "longitude": "",
          "placeId": ""
        });

        // Reset the error styling
        setInputErrorToggle(false);

        // Show/hide the "clear" button
        if (clearInputButton !== undefined) {
          if (value.length !== 0) {
            // Show the "clear" button if there is an input value to clear
            clearInputButton.classList.add('is-active');
          } else {
            // Hide the "clear" button
            clearInputButton.classList.remove('is-active');
          }
        }

        if (value.length >= 3) {
          // Trigger the location suggestions dropdown
          getLocationSuggestions(value)
          .then( (data) => {
            // Check for any returned errors
            if (data.status === "OK") {
              // Address data was returned, update the input dropdown
              setLocationSuggestions(data.predictions.map( (prediction) => {
                return {
                  "address": prediction.description,
                  "place_id": prediction.place_id
                }
              }));
            } else {
              if (data.status === "ZERO_RESULTS") {
                setLocationSuggestions([{
                  "address": "No locations found for that address",
                  "place_id": ""
                }]);
                // Show the error styling
                setInputErrorToggle(true);
              } else {
                // Likely a general error has occurred.
                setAlertMessage(`There has been a problem retrieving location data. The API returned an error message. Error: ${data.status}`);
              }
            }
          })
          .catch( (errorObject) => {
            if (errorObject.eventType === 'error') {
              setAlertMessage(`There has been a problem retrieving location data. Status code: ${errorObject.response.status}`);
            }
          });
        } else {
          // Remove the suggestions
          setLocationSuggestions([]);
        }
      }

      /**
       * Respond to clicks on the "Clear" input button
       *
       * @param {Click Event} evt Event that triggered the clear
       */
      function onClearInputClick(evt) {
        evt.preventDefault();

        // Hide the "clear" button
        clearInputButton.classList.remove('is-active');

        // Reset the error styling
        setInputErrorToggle(false);

        // Clear any user location that has been captured already
        setLocation({
          "fullAddress": "",
          "suburb": "",
          "postcode": "",
          "latitude": "",
          "longitude": "",
          "placeId": ""
        });

        // Remove the suggestions
        setLocationSuggestions([]);
      }

      /**
       * Respond to clicks on the address location suggestions
       *
       * @param {Click Event} evt Event that triggered the selection
       */
      function onOutageSuggestionClick(evt) {
        evt.preventDefault();

        let placeID = evt.target.getAttribute('data-placeid');

        // Update the form fields with the selected suggestion
        setLocation({
          "fullAddress": evt.target.value,
          "placeId": placeID
        });

        // Remove the suggestions
        setLocationSuggestions([]);

        // Make the request to get the address info (specifically, the postcode and locality)
        getPlaceData(placeID)
          .then( (data) => {
            // Capture the additional address data needed
            let postcode = "";
            let suburb = "";
            let latitude = "";
            let longitude = "";
            let latLong = "";

            // Check for any returned errors
            if (data.status === "OK") {
              // Location data was returned, capture the data we need
              for (var i = 0, j = data.result.address_components.length; i < j; ++i) {
                if (data.result.address_components[i].types[0] === 'postal_code') {
                  postcode = data.result.address_components[i].short_name;
                }

                if (data.result.address_components[i].types[0] === 'locality') {
                  suburb = data.result.address_components[i].short_name;
                }
              }

              // Capture the lat/lng
              latitude = data.result.geometry.location.lat.toString();
              longitude = data.result.geometry.location.lng.toString();
              latLong = `${latitude},${longitude}`;

              // We don't always get the data we need back from this API (e.g. businesses, centres).
              // Try a different endpoint using the lat/lng from the previous response.
              if (postcode === "" || suburb === "") {
                // Make the request to get locations for the lat/lng
                getLatLongData(latLong)
                  .then( (data) => {
                    let postcode = "";
                    let suburb = "";

                    // Take the first suggestion and update the state with the address
                    if (data.results.length > 0) {
                      // Try to find the address postcode and suburb
                      for (var i = 0, j = data.results[0].address_components.length; i < j; ++i) {
                        if (data.results[0].address_components[i].types[0] === 'postal_code') {
                          postcode = data.results[0].address_components[i].short_name;
                        }

                        if (data.results[0].address_components[i].types[0] === 'locality') {
                          suburb = data.results[0].address_components[i].short_name;
                        }
                      }

                      // Update the form fields with the first suggestion
                      setLocation({
                        "postcode": postcode,
                        "suburb": suburb,
                        "latitude": latitude,
                        "longitude": longitude
                      });

                      checkServicedPostcode(postcode);
                    }

                    if (postcode.length === 0) {
                      // We need the postcode for the outage data filtering, so alert the user if we couldn't get that data
                      setAlertMessage("We were unable to determine your postcode, please try searching for a different address.");
                    }
                  })
                  .catch( (errorObject) => {
                    if (errorObject.eventType === 'error') {
                      setAlertMessage(`There has been a problem retrieving your address information. Status code: ${errorObject.response.status}`);
                    }
                  });
              } else {
                // We got the data we needed from the Place Details API.
                // Update the form fields with the postcode and lat/long co-ords
                setLocation({
                  "postcode": postcode,
                  "suburb": suburb,
                  "latitude": latitude,
                  "longitude": longitude
                });

                checkServicedPostcode(postcode);
              }
            } else {
              // Likely an error has occurred.
              setAlertMessage(`There has been a problem retrieving information about your selected address. The API returned an error message. Error: ${data.status}`);
            }
          })
          .catch( (errorObject) => {
            if (errorObject.eventType === 'error') {
              setAlertMessage(`There has been a problem retrieving information about your selected address. Status code: ${errorObject.response.status}`);
            }
          });
      }

      /**
       * Respond to clicks on the "Use my location" button
       * Note: To test this locally you need to access the page via: localhost
       *
       * @param {Click Event} evt Event that triggered the click
       *
       * @returns void
       */
      function onGeoLocateClick(evt) {
        evt.preventDefault();

        const geoLocateButton = evt.currentTarget;

        // Add the loading styling
        geoLocateButton.classList.add('is-loading');

        // Request the user's location
        navigator.geolocation.getCurrentPosition(onGeoLocateSuccess, onGeoLocateFail);

        function onGeoLocateSuccess(position) {
          const latLong = `${position.coords.latitude},${position.coords.longitude}`;

          // Update the form fields with the returned lat/long co-ords
          setLocation({
            "latitude": position.coords.latitude.toString(),
            "longitude": position.coords.longitude.toString()
          });

          // Make the request to get locations for the lat-long
          getLatLongData(latLong)
            .then( (data) => {
              let postcode = "";
              let suburb = "";

              // Take the first suggestion and update the form fields with the address info
              if (data.results.length > 0) {
                // Try to find the address postcode and suburb
                for (var i = 0, j = data.results[0].address_components.length; i < j; ++i) {
                  if (data.results[0].address_components[i].types[0] === 'postal_code') {
                    postcode = data.results[0].address_components[i].short_name;
                  }

                  if (data.results[0].address_components[i].types[0] === 'locality') {
                    suburb = data.results[0].address_components[i].short_name;
                  }
                }

                // Update the form fields with the address from the first suggestion
                setLocation({
                  "fullAddress": data.results[0].formatted_address,
                  "suburb": suburb,
                  "postcode": postcode,
                  "placeId": data.results[0].place_id
                });

                // Show the "clear" button
                if (clearInputButton !== undefined) {
                  clearInputButton.classList.add('is-active');
                }

                checkServicedPostcode(postcode);
              }

              if (postcode.length === 0) {
                // We need the postcode for the outage data filtering, so alert the user if we couldn't get that data
                setAlertMessage("We were unable to determine your postcode, please try searching for your address.");
              }

              // Remove the loading styling
              geoLocateButton.classList.remove('is-loading');
            })
            .catch( (errorObject) => {
              if (errorObject.eventType === 'error') {
                setAlertMessage(`There has been a problem retrieving your address information. Status code: ${errorObject.response.status}`);
              }

              // Remove the loading styling
              geoLocateButton.classList.remove('is-loading');
            });
        }

        function onGeoLocateFail() {
          setAlertMessage("We were unable to determine your location, you may need to allow this site to access your location. Otherwise, please try searching for your address.");

          // Remove the loading styling
          geoLocateButton.classList.remove('is-loading');
        }
      }

      /**
       * Request some suggestions from the location API
       *
       * @param {String} input The address, or partial address, to lookup
       *
       * @returns Promise
       */
      function getLocationSuggestions(input) {
        let url = "";
        let sanitisedInput = "";
        let requestPromise = null;

        // Abort any current request
        xhrDataRequest.abort();

        // Generate a new request (this clears any current listeners)
        xhrDataRequest = new XMLHttpRequest();

        // Create our new Promise
        requestPromise = newRequestPromise(xhrDataRequest);

        // Clear up the address input
        sanitisedInput = encodeURIComponent(input).replace(/%20/g, '+');

        // Assemble the request URL
        url = `${configuration.googlePlacesApiEndpoint}?address=${sanitisedInput}`;

        // Set up our request
        xhrDataRequest.open("GET", url);

        // Make the request
        xhrDataRequest.send();

        return requestPromise;
      }

      /**
       * Request further information on the user-selected address
       *
       * @param {String} placeid The Google Places API Place ID value
       *
       * @returns Promise
       */
      function getPlaceData(placeid) {
        let url = "";
        let requestPromise = null;

        // Abort any current request
        xhrDataRequest.abort();

        // Generate a new request (this clears any current listeners)
        xhrDataRequest = new XMLHttpRequest();

        // Create our new Promise
        requestPromise = newRequestPromise(xhrDataRequest);

        // Assemble the request URL
        url = `${configuration.googlePlaceDetailsApiEndpoint}?placeid=${placeid}`;

        // Set up our request
        xhrDataRequest.open("GET", url);

        // Make the request
        xhrDataRequest.send();

        return requestPromise;
      }

      /**
       * Request possible address locations from provided latitude and longitude co-ordinates
       *
       * @param {String} latLong The latitude and longitude co-ordinates to lookup. e.g. "-33.8666677,151.2021696"
       *
       * @returns Promise
       */
      function getLatLongData(latLong) {
        let url = "";
        let requestPromise = null;

        // Abort any current request
        xhrDataRequest.abort();

        // Generate a new request (this clears any current listeners)
        xhrDataRequest = new XMLHttpRequest();

        // Create our new Promise
        requestPromise = newRequestPromise(xhrDataRequest);

        // Assemble the request URL
        url = `${configuration.googleGeocodingApiEndpoint}?latlng=${latLong}`;

        // Set up our request
        xhrDataRequest.open("GET", url);

        // Make the request
        xhrDataRequest.send();

        return requestPromise;
      }

      /**
       * Update the individual location fields with location data
       * An Object should be provided for each of the values to be set.
       * If a value is not provided, then the corresponding field will not be updated.
       *
       * @param {Object} An Object of key/value pairs
       *
       * @returns void
       */
      function setLocation({ fullAddress = null, suburb = null, postcode = null, latitude = null, longitude = null, placeId = null }) {
        let locationSuburbField = document.getElementsByName('suburb');
        let locationPostcodeField = document.getElementsByName('postcode');
        let locationLatitudeField = document.getElementsByName('lat');
        let locationLongitudeField = document.getElementsByName('lng');
        let locationPlaceIdField = document.getElementsByName('placeId');

        // Update the input field with the address
        if (fullAddress !== null) {
          locationInputField.value = fullAddress;
        }

        // Update the individual fields
        if (suburb !== null && locationSuburbField.length !== 0) {
          locationSuburbField[0].value = suburb;
        }

        if (postcode !== null && locationPostcodeField.length !== 0) {
          locationPostcodeField[0].value = postcode;
        }

        if (latitude !== null && locationLatitudeField.length !== 0) {
          locationLatitudeField[0].value = latitude;
        }

        if (longitude !== null && locationLongitudeField.length !== 0) {
          locationLongitudeField[0].value = longitude;
        }

        if (placeId !== null && locationPlaceIdField.length !== 0) {
          locationPlaceIdField[0].value = placeId;
        }
      }

      /**
       * Update the outage location suggestions dropdown
       *
       * @param {Array} suggestionArray Array of options to use as the suggestions.
       * Each item in the Array should be an Object of the format:
       * {
          "address": "Full address",
          "place_id": "Google Place ID"
       * }
       *
       * @returns void
       */
      function setLocationSuggestions(suggestionArray) {
        const suggestionMarkupArray = [];
        let suggestionButtons = [];

        // Show or hide the suggestions
        if (suggestionArray.length !== 0) {
          locationInputField.classList.add('is-active');
        } else {
          locationInputField.classList.remove('is-active');
        }

        // Generate and update the dropdown options
        for (var i = 0, j = suggestionArray.length; i < j; ++i) {
          suggestionMarkupArray.push(`
            <li class="outage-checker-suggestions__list-item">
              <button class="js-outage-suggestion outage-checker-suggestions__button" value="${suggestionArray[i].address}" data-placeid="${suggestionArray[i].place_id}">${suggestionArray[i].address}</button>
            </li>
          `);
        }

        locationSuggestionsDropdown.innerHTML = suggestionMarkupArray.join('');

        // Add listeners to the new buttons
        if (suggestionArray.length !== 0) {
          suggestionButtons = locationSuggestionsDropdown.getElementsByClassName('js-outage-suggestion');

          for (var b = 0, w = suggestionButtons.length; b < w; ++b) {
            suggestionButtons[b].addEventListener('click', onOutageSuggestionClick);
          }
        }
      }

      /**
       * Check if the provided postcode is in the list of serviced areas
       *
       * @param {String} postcode The postcode to check
       * @param {Array} postcodeArray The list of accepted postcodes
       *
       * @returns void
       */
      function checkServicedPostcode(postcode) {
        const postcodeArray = configuration.franchisePostcodes;
        let servicedArea = false;

        for (var i = 0, j = postcodeArray.length; i < j; ++i) {
          if (postcodeArray[i] === postcode) {
            servicedArea = true;
            break;
          }
        }

        if (!servicedArea) {
          // The user is not in a location serviced by Endeavour Energy, show a message
          setAlertMessage('Sorry, Endeavour Energy does not supply this area.');
        }
      }

      /**
       * Create a new Promise that we can use to response to asynchronus XML Http Requests
       *
       * @param {XMLHttpRequest} xhrRequest The XMLHttpRequest to attach the event listeners to
       *
       * @returns Promise
       */
      function newRequestPromise(xhrRequest) {
        return new Promise( (resolve, reject) => {
          // Respond to requests to GET the data
          xhrRequest.addEventListener('load', function(evt) {
            if (evt.currentTarget.status === 200) {
              // We got a good response
              resolve(JSON.parse(evt.currentTarget.response));
            } else {
              // We got a bad response (e.g. 403, 404)
              reject( {
                "response": evt.currentTarget,
                "eventType": 'error'
                }
              );
            }
          });

          // Respond to request errors
          xhrRequest.addEventListener('error', function(evt) {
            reject( {
              "response": evt.currentTarget,
              "eventType": 'error'
              }
            );
          });

          // Respond to request aborts
          xhrRequest.addEventListener('abort', function(evt) {
            reject( {
              "response": evt.currentTarget,
              "eventType": 'abort'
              }
            );
          });
        });
      }

      /**
       * Display the alert popup with an alert message as feedback for the user
       *
       * @param {String} msg The message to display
       *
       * @returns void
       */
      function setAlertMessage(msg) {
        // Set the alert content
        alertMessage.textContent = msg;

        // Show the alert popup
        alertMessagePopup.classList.add('is-active');
      }

      /**
       * Hide the alert popup
       *
       * @param {Click Event} evt Click Event on the button
       *
       * @returns void
       */
      function onAlertCloseClick(evt) {
        evt.preventDefault();

        // Hide the alert popup
        alertMessagePopup.classList.remove('is-active');
      }

      /**
       * Show/hide the address search error styling
       *
       * @returns void
       */
      function setInputErrorToggle(showError) {
        if (showError) {
            locationInputField.classList.add('has-error');
        } else {
            locationInputField.classList.remove('has-error');
        }
      }
    };

    /**
     * Check through a given query string and return all values that match a provided key.
     *
     * @param {String} queryString The full query string (without the question mark). e.g. id=1234&src=home&campaign-ID=r569_WW&f.Type|type=abc&f.Type|type=xyz
     * @param {String} key The key of the options to be matched. e.g. f.Type|type
     *
     * @returns Array of matched values
     */
    squiz.fn.getQueryParameterValuesByKey = (queryString, key) => {

      var queryKeyValues = [],
          allQueryParameters = [],
          currentParameter = [],
          s_EscapedQueryKey = '',
          valueTest = {};

      // Split all the query values into an Array
      allQueryParameters = queryString.split('&');

      // Escape any special characters in the query key
      s_EscapedQueryKey = key.replace(/\./g, "\\.").replace(/\|/g, "%7C").replace(/\+/g, "\\+");

      // Assemble the RegExp
      valueTest = new RegExp('(?=^|&)' + s_EscapedQueryKey + '=(.*?)(?=&|$)');

      // Check all the parameters for a key match and extract the value
      for (var i = 0, j = allQueryParameters.length; i < j; ++i) {

        currentParameter = allQueryParameters[i].match(valueTest);

        if (currentParameter !== null) {
          queryKeyValues.push(currentParameter[1]);
        }
      }

      return queryKeyValues;
    }

    /**
     * Check through a given query string and remove all values that match a provided key.
     *
     * @param {String} queryString The full query string (or URL). e.g. id=1234&src=home&campaign-ID=r569_WW&f.Type|type=abc&f.Type|type=xyz
     * @param {String} key The key of the options to be matched. e.g. f.Type|type
     *
     * @returns The query string with all the keys and values removed for the provided key
     */
    squiz.fn.removeQueryParameterValuesByKey = (queryString, key) => {

      var updatedQueryKeyValues = [],
          allQueryParameters = [],
          currentParameter = [],
          s_EscapedQueryKey = '',
          valueTest = {};

      // Split all the query values into an Array
      allQueryParameters = queryString.split('&');

      // Escape any special characters in the query key
      s_EscapedQueryKey = key.replace(/\./g, "\\.").replace(/\|/g, "%7C").replace(/\+/g, "\\+");

      // Assemble the RegExp
      valueTest = new RegExp('(?=^|&)' + s_EscapedQueryKey + '=(.*?)(?=&|$)');

      // Check all the parameters for a key match and extract the value
      for (var i = 0, j = allQueryParameters.length; i < j; ++i) {

        currentParameter = allQueryParameters[i].match(valueTest);

        if (currentParameter !== null) {
          // This is a matching key, so skip this pair
          continue;
        }

        updatedQueryKeyValues.push(allQueryParameters[i]);
      }

      return updatedQueryKeyValues.join('&');
    }

    /**
     * Utility function for suppressing default button behaviour.
     *
     * @param {Click Event} evt Click Event on the button
     *
     * @returns void
     */
    squiz.fn.buttonPreventDefault = (evt) => {
        const targetElementType = evt.target.nodeName.toLowerCase();

        // <a> elements should still be allowed to work
        if (targetElementType !== 'a') {
            evt.preventDefault();
        }
    }

    // Make squiz variable available to the console for debugging
    window.squiz = squiz;

    // Toggle the search menu on mobile
    squiz.fn.mobileMenuToggle('js-toggle-mobile-search', 'js-mobile-search-target');

    // Toggle the site main menu on mobile
    squiz.fn.mobileMenuToggle('js-toggle-mobile-menu', 'js-mobile-menu-target');


    // Initialise the accordions in the site mobile menu
    $(window).ready(function(){
        if (!window.matchMedia('screen and (min-width:1300px)').matches) {
          // Only convert the main nav into accordions on mobile screens.
          // Initialise the accordions for the main nav
          $('.js-mobile-menu-accordion').accordion({
            'useCSSTransitions': true,
            'selector': '.js-mobile-menu-accordion'
          });

          // Fix the issue we have with the Search Autocomplete dropdown on mobile.
          // The accordion overflow hides the autocomplete options unless we override it.
          $('.js-mobile-search-target').on('transitionend', function() {
            if ($(this).hasClass('is-visible')) {
              $(this).css('overflow', 'visible');
            }
          });

          $('.js-mobile-search-target').on('transitionstart', function() {
            if (!$(this).hasClass('is-visible')) {
              $(this).css('overflow', 'hidden');
            }
          });
        }

    });

    $('.main table').each(function() {
      var $table = $(this);
      $table.wrap('<div class="table"></div>');
    });

    /**
     * Google Translate dropdown
     */
    var googleTranslate = {
      /**
       * Config vars
       */
      apiProxy: "",
      translationNode: document.body,
      observeMutationsOn: [],
      nodeListSourceLanguage: [],
      nodeListTextLanguage: [],
      excludeElements: [],
      mutatationIds: [],
      sourceLanguage: "",
      targetLanguage: "",
      nodeList: [],
      nodeTextList: [],
      mutationNodeList: [],
      mutationTextList: [],

      /**
       * Recursively traverse though DOM using a start node
       * @param {object} el - start traversing at DOM node
       * @param {arr} nodeList - array of DOM nodes
       * @param {arr} nodeTextList - array of DOM node text
       */
      traverseTextNodes: function traverseTextNodes(el) {
          var nodeList =
              arguments.length > 1 && arguments[1] !== undefined
                  ? arguments[1]
                  : this.nodeList;
          var nodeTextList =
              arguments.length > 2 && arguments[2] !== undefined
                  ? arguments[2]
                  : this.nodeTextList;
          el.childNodes.forEach(
              function(el) {
                  if (
                      !this.excludeElements.includes(el) &&
                      el.tagName !== "SCRIPT" &&
                      el.tagName !== "STYLE"
                  ) {
                      // If this is a text node, replace the text
                      if (el.nodeType === 3 && el.nodeValue.trim() !== "") {
                          nodeList.push(el);
                          nodeTextList.push(el.nodeValue.trim());
                      } else {
                          this.traverseTextNodes(el, nodeList, nodeTextList);
                      }
                  }
              }.bind(this)
          );
      },

      /**
       * Translate nodes (calls Google Translate API )
       * @param {arr} nodeList - array containing list of nodes to be translated
       * @param {arr} nodeTextList - array of text that requires translation
       * @return {promise} - return a promise (resolve to a boolean value)
       */
      translate: function translate() {
          var nodeList =
              arguments.length > 0 && arguments[0] !== undefined
                  ? arguments[0]
                  : this.nodeList;
          var nodeTextList =
              arguments.length > 1 && arguments[1] !== undefined
                  ? arguments[1]
                  : this.nodeTextList;
          var request = new XMLHttpRequest();
          request.open("POST", this.apiProxy, true);
          request.setRequestHeader(
              "Content-Type",
              "application/json;charset=UTF-8"
          );
          return new Promise(
              function(resolve) {
                  request.onload = function() {
                      if (this.status >= 200 && this.status < 400) {
                          var resp = JSON.parse(this.response);

                          if (resp.error) {
                              console.log(resp.error);
                              resolve(false);
                          } else {
                              resp.translations.forEach(function(
                                  translation,
                                  index
                              ) {
                                  nodeList[index].nodeValue =
                                      translation.translatedText;
                              });
                              resolve(true);
                          }
                      } else {
                          console.error("API Error: " + this.status);
                          resolve(false);
                      }
                  };

                  request.onerror = function() {
                      console.error("Could not connect to API.");
                  };

                  request.send(
                      JSON.stringify({
                          sourceLanguageCode: this.sourceLanguage,
                          targetLanguageCode: this.targetLanguage,
                          mimeType: "text/plain",
                          contents: nodeTextList
                      })
                  );
              }.bind(this)
          );
      },

      /**
       * Observe mutations on a node & its children
       * @param {object} targetNode - source node object
       */
      mutationListener: function mutationListener(targetNode) {
          var config = {
              childList: true,
              subtree: true
          };

          var callback = function(mutationsList) {
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                  for (
                      var _iterator = mutationsList[Symbol.iterator](), _step;
                      !(_iteratorNormalCompletion = (_step = _iterator.next())
                          .done);
                      _iteratorNormalCompletion = true
                  ) {
                      var mutation = _step.value;

                      if (mutation.type === "childList") {
                          var element = document.getElementById(
                              mutation.target.id
                          );
                          this.mutationNodeList = [];
                          this.mutationTextListList = [];
                          this.traverseTextNodes(
                              element,
                              this.mutationNodeList,
                              this.mutationTextListList
                          );
                          this.translate(
                              this.mutationNodeList,
                              this.mutationTextListList
                          );
                      }
                  }
              } catch (err) {
                  _didIteratorError = true;
                  _iteratorError = err;
              } finally {
                  try {
                      if (
                          !_iteratorNormalCompletion &&
                          _iterator.return != null
                      ) {
                          _iterator.return();
                      }
                  } finally {
                      if (_didIteratorError) {
                          throw _iteratorError;
                      }
                  }
              }
          }.bind(this);

          var observer = new MutationObserver(callback);
          observer.observe(targetNode, config);
      },

      /**
       * Set target language by triggering translation API call
       * Persist language preference to localStorage
       * @param {string} langCode -  language code in ISO format
       * @return {promise} - return a promise (resolve to a boolean value)
       */
      setTargetLanguage: function setTargetLanguage(langCode) {
          localStorage.setItem("gTranslate_lang", langCode);

          if (
              langCode === this.sourceLanguage ||
              this.mutationNodeList.length > 0
          ) {
              location.reload();
              return new Promise(function(resolve) {
                  resolve(true);
              });
          }

          this.targetLanguage = langCode;
          return this.translate();
      },

      /**
       * Initialize Google Translate
       * @param {object} config - init config object
       * @return {promise} - return a promise (resolve to a boolean value)
       */
      init: function init(config) {
          //required
          this.apiProxy = config.apiProxy;
          this.sourceLanguage = config.sourceLanguage;

          if (config.node !== undefined) {
              this.translationNode = document.body;
          }

          if (config.excludeElements !== undefined) {
              this.excludeElements = config.excludeElements;
          }

          this.traverseTextNodes(this.translationNode);
          var targetLanguage = localStorage.getItem("gTranslate_lang"); //check lang pref. and set if different from src lang

          if (targetLanguage !== null && targetLanguage !== this.sourceLanguage) {
              return this.setTargetLanguage(targetLanguage);
          } else {
              return new Promise(function(resolve) {
                  resolve(true);
              });
          } //attach events

          // if (config.observeMutationsOn.length > 0) {
          //     config.observeMutationsOn.forEach(
          //         function(el) {
          //             this.mutationListener(el);
          //         }.bind(this)
          //     );
          // }
      }
    };

    window.addEventListener('load', () => {

      if (document.getElementsByClassName("select-lang").length !== 0) {
        var gtranslateInit = googleTranslate.init({
          apiProxy: window.googleTranslateApiProxy,
          excludeElements: [document.getElementsByClassName("select-lang")[0], document.getElementsByClassName("select-lang")[1]],
          sourceLanguage: "en"
        });
        gtranslateInit.then(function (response) {
            document.getElementById("google_translate_popup").style.display = "none";
            if (!response) {
                alert('There was a problem with translating this page. Please refresh the page and try again. If the problem persists, please contact the website administrator.');
            }
        });
        var langSelectFields = document.getElementsByClassName("select-lang");

        if (localStorage.getItem("gTranslate_lang") !== null && localStorage.getItem("gTranslate_lang") !== "") {
          for (var i = 0, j = langSelectFields.length; i < j; ++i) {
            langSelectFields[i].value = localStorage.getItem("gTranslate_lang");
          }
        }

        for (var k = 0, b = langSelectFields.length; k < b; ++k) {
          langSelectFields[k].addEventListener("change", function (e) {
            if (e.target.value !== "" && e.target.value !== "Select language") {
              var translatePromise = googleTranslate.setTargetLanguage(e.target.value);
              document.getElementById("google_translate_popup").style.display = "block";
              translatePromise.then(function (response) {
                document.getElementById("google_translate_popup").style.display = "none";

                if (!response) {
                  alert('There was a problem with translating this page. Please refresh the page and try again. If the problem persists, please contact the website administrator.');
                }
              });
            }
          });
        }
      }
    });

  
  
  
  // %%%%%%%%%%% Site alert functions %%%%%%%%%%%

  // hashing function
  // https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/digest
  let alertCookieLengthInHours = parseFloat($('.site-alert__cookie-timeout').html());
    
    async function digestMessage(message) {
        const msgUint8 = new TextEncoder().encode(message);                           // encode as (utf-8) Uint8Array
        const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8);           // hash the message
        const hashArray = Array.from(new Uint8Array(hashBuffer));                     // convert buffer to byte array
        const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join(''); // convert bytes to hex string
        return hashHex;
     }


    function setCookie(cookieKey, cookieValue, expireHours) {
      let cookie = cookieKey + "=" + cookieValue;
      const d = new Date();
      d.setTime(d.getTime() + (expireHours*60*60*1000));
      let expires = "expires=" + d.toUTCString();

      document.cookie = cookie + ";" + expires + ";path=/";
    }
    
    function readCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }

    function delete_cookie(name) {
        document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }

    function checkSiteAlertCookie() {                                       
        let currentAlertMessage = $('.site-alert__title').html();
        
        let prevDismissedMessageHash = readCookie('endeavourenergy_sitealertdismissedmessage');

        digestMessage(currentAlertMessage).then((result)=>{
            if (result === prevDismissedMessageHash) {      // compare current message and last closed message hashes
              return;
            } else {
              $('.site-alert__container').addClass('active');
              delete_cookie('endeavourenergy_sitealertdismissedmessage');
            }
        });
    }
  
    function setAlertCookie() {                                 
        let currentAlertMessage = $('.site-alert__title').html();
    
        digestMessage(currentAlertMessage).then((res) => {
            setCookie("endeavourenergy_sitealertdismissedmessage", res, alertCookieLengthInHours);
        })
    }
  
    // close alert
    $('.site-alert__close-btn').on('click', function () {
        setAlertCookie();
      $('.site-alert__container').removeClass('active');
    })
  
    if (crypto.subtle !== undefined) {
        checkSiteAlertCookie();
    }
}());